<div class="sz-chip-row" role="group">
  @for (option of options(); track option.value) {
    <button
      type="button"
      class="sz-chip-row__chip"
      [class.is-selected]="option.value === value()"
      [disabled]="disabled()"
      (click)="select(option.value)">
      {{ option.label }}
    </button>
  }
</div>
